import IconLoop from './icon_loop.svg';
import s from './index.module.scss';

export const EmptyContent = ({ title, text }) => {
  return (
    <div className={s.wrapper}>
      <div className={s.icon}>
        <img src={IconLoop} alt="empty" width={24} height={24} />
      </div>
      <div className="f-article-accent">{title}</div>
      <div
        className="f-small-regular"
        style={{ color: 'var(--Black-100, #414141)' }}
      >
        {text}
      </div>
    </div>
  );
};
